import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { "aria-label": "breadcrumb" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb-separator"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_7 = { class: "current" }

import { computed } from "vue";
import { useRoute } from "vue-router";

interface Breadcrumb {
  label: string;
  to: { name: string; path: string };
  rootPath?: string;
  isActive: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    rootPath: {},
    showJumpTo: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();

const breadcrumbs = computed<Breadcrumb[]>(() => {
  let accumulatedPath = props.rootPath;

  return route.matched.map((match, index): Breadcrumb => {
    const label =
      (match.meta?.breadcrumb as string) || match.name?.toString() || "???";

    if (match.meta?.breadcrumbDetails) {
      const breadcrumbDetails = match.meta?.breadcrumbDetails as Breadcrumb;

      return {
        label,
        to: {
          name: breadcrumbDetails?.to?.name || label,
          path: breadcrumbDetails.to?.path,
        },
        isActive: breadcrumbDetails.isActive,
      };
    }

    if (index > 0) {
      accumulatedPath += `/${match.path.split("/").pop()}`;
    }

    return {
      label,
      to: { name: label, path: accumulatedPath },
      isActive: index === route.matched.length,
    };
  });
});

const parameterBreadcrumb = computed(() => {
  const paramValue =
    route.params.id || route.params.referenceId || route.params.batchId;
  return paramValue &&
    paramValue !== breadcrumbs.value[breadcrumbs.value.length - 1]?.label
    ? paramValue
    : null;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["breadcrumb-container-wrapper", { showJumpTo: __props.showJumpTo }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["breadcrumb-container", { 'flex-container-row': __props.showJumpTo }])
    }, [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: { path: __props.rootPath }
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "icon-home" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ]),
          _renderSlot(_ctx.$slots, "breadcrumbs", {}, () => [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "breadcrumb-separator" }, " > ", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (breadcrumb, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "breadcrumb-item"
              }, [
                (index > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, " > "))
                  : _createCommentVNode("", true),
                (!breadcrumb.isActive)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { name: breadcrumb.to.name }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(breadcrumb.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(breadcrumb.label), 1))
              ]))
            }), 128)),
            (parameterBreadcrumb.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "breadcrumb-separator" }, " > ", -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(parameterBreadcrumb.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "loanservice-banner")
    ], 2),
    _renderSlot(_ctx.$slots, "jumpto")
  ], 2))
}
}

})